import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import PurchasePanelMixin from "@components/PDP/PurchasePanelMixin";

export default {
  mixins: [PurchasePanelMixin],

  props: {
    ctaSource: {
      type: String,
      required: true
    }
  },

  render() {
    if (this.$slots.default) {
      return this.$slots.default({
        addProductToOrderOrBag: this.addProductToOrderOrBag,
        addToBag: this.addToBag,
        canAddToRefillCart: this.canAddToRefillCart,
        addingToBag: this.addingToCart,
        addToBagExistingProdObj: this.addToBagExistingProdObj,
      })?.[0];
    }
    return null;
  },

  computed: {
    ...mapState('cms', ['cmsSettings']),
    ...mapState('pdp', [
      'product',
      'purchaseType',
      'qty',
      'subFrequency',
      'skipPurchasePanel',
      'extraTube',
      'addPerfectPair',
      'attachableProdIds'
    ]),
    ...mapState('cart', [
      'cart',
      'addingProduct',
    ]),

    ...mapState('refillCart', [
      'modifyingRefillProduct'
    ]),

    ...mapState('systemSettings', [
      'rcdSystemSettings'
    ]),

    ...mapState('colorAdvisor', [
      'answers'
    ]),

    ...mapGetters('xsell', ['xsellGloss']),
    ...mapGetters('cart', ['productMaxQtyInCart']),
    ...mapGetters('pdp', [
      'perfectPairEligible',
      'showPerfectPairOnPdp',
      'isPurePigment',
      'perfectPairGloss'
    ]),

    ...mapGetters('refillCart', [
      'productMaxQtyInRefillCart',
      'baseSubscription',
      'refillCartIsApplePay'
    ]),

    addingToCart() {
      return this.addingToBag || this.addingProduct || Boolean(this.modifyingRefillProduct);
    },

    //- check if the active sub in refill cart accepts this product as attachable
    canAttachThisItem() {
      return (this.baseSubscription.subscriptionAttachments || []).some(att => att.code == this.product.product_type) && !this.refillCartIsApplePay;
    },

    //- as long as user has active sub in refill cart, any item should be available as one-time addon
    canOneTimeAddToOrder() {
      return Boolean(this.baseSubscription.id) && !this.refillCartIsApplePay;
    },

    canAddToRefillCart() {
      return this.canAttachThisItem || this.canOneTimeAddToOrder;
    },
  },

  methods: {
    ...mapActions([
      'notifyWarn',
      'notifyError'
    ]),
    ...mapActions('cart', [
      'addToCart',
      'addMultipleItemsToCart'
    ]),
    ...mapActions('pdp', [
      'openPurchasePanelModal',
      'openPurchasePanelAttachModal',
      'openPurchasePanelSimpleModal',
      'openPdpXsell',
      'openKeepShoppingModal'
    ]),

    ...mapActions('modal', ['showModal']),

    ...mapMutations('pdp', [
      'setProduct',
      'setAddPerfectPair',
      'clearAttachableProdIds'
    ]),

    addProductToOrderOrBag(returnFocusElement) {
      if (this.productMaxQtyInRefillCart(this.product.id)) {
        this.notifyWarn('Max Quantity already in upcoming order. Please contact Customer Service for larger quantities.');
        return;
      }

      if (this.productMaxQtyInCart(this.product.id)) {
        this.notifyWarn('Max Quantity already in cart. Please contact Customer Service for larger quantities.');
        return;
      }

      if (this.perfectPairEligible && (this.rcdSystemSettings.showPerfectPairModule || this.showPerfectPairOnPdp)) {
        this.openPerfectPairModal(returnFocusElement);
      } else if (this.canAttachThisItem) {
        //- present with a choice: one-time or attachable
        this.openPurchasePanelAttachModal({ returnFocusElement });
      } else if (this.canOneTimeAddToOrder) {
        this.mix_trackEvent('Added to Bag - Refill Cart', { 
          productType: this.product.product_type,
          productCode: this.product.code,
          productName: this.product.name,
         });
        //- add straight to refill cart as one-time and redirect
        this.mix_addProductToRefillCart(false, this.ctaSource);
      } else {
        this.addToBag(returnFocusElement);
      }
    },

    openPerfectPairModal(returnFocusElement) {
      this.showModal({
        component: 'PerfectPairModal',
        props: {
          colorKit: this.product,
          gloss: this.perfectPairGloss,
          addFunction: this.perfectPairModalAction.bind(null, true),
          noThanksFunction: this.perfectPairModalAction.bind(null,false)
        },
        theme: 'full-screen',
        returnFocusElement
      });
    },

    perfectPairModalAction(addPerfectPair) {
      this.setAddPerfectPair(addPerfectPair);
      this.addToBag();
    },

    addToBag(returnFocusElement) {
      this.mix_addToBag(returnFocusElement, this.ctaSource);
    },

    addToBagExistingProdObj(existingProdObj, returnFocusElement) {
      this.setProduct(existingProdObj);
      this.mix_addToBag(returnFocusElement, this.ctaSource);
    },
  }
};
